let handler = null;
let unlockHandler = null;
// Last import percentage per project. This module is a federation singleton,
// so a section that mounts mid-import (in any MFE) starts from the latest
// value instead of 0 while it waits for the next socket message.
const importProgress = new Map();
export function getImportProgress(projectId) {
    return importProgress.get(projectId) ?? null;
}
export function setImportProgress(projectId, percentage) {
    importProgress.set(projectId, percentage);
}
export function clearImportProgress(projectId) {
    importProgress.delete(projectId);
}
export function registerGlobalLockHandler(fn) {
    if (import.meta.env.VITE_ENVIRONMENT !== 'production' && handler !== null) {
        console.warn('[globalLock] Handler already registered. Duplicate mount?');
    }
    handler = fn;
    return () => {
        if (handler === fn) {
            handler = null;
        }
    };
}
export function triggerGlobalLock(payload) {
    if (!handler) {
        if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
            console.warn('[globalLock] triggerGlobalLock called with no handler registered.');
        }
        return;
    }
    handler(payload);
}
export function registerGlobalUnlockHandler(fn) {
    if (import.meta.env.VITE_ENVIRONMENT !== 'production' &&
        unlockHandler !== null) {
        console.warn('[globalLock] Unlock handler already registered.');
    }
    unlockHandler = fn;
    return () => {
        if (unlockHandler === fn) {
            unlockHandler = null;
        }
    };
}
export function triggerGlobalUnlock(payload) {
    // Releasing the whole project means its import has ended.
    if (!payload.sectionType) {
        clearImportProgress(payload.projectId);
    }
    if (!unlockHandler) {
        if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
            console.warn('[globalLock] triggerGlobalUnlock called with no handler registered.');
        }
        return;
    }
    unlockHandler(payload);
}
//# sourceMappingURL=globalLock.js.map